<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body">
    <h1 class="product-name">{{product.name}}</h1>
    <h2 class="size" *ngIf="product.level">{{product.size}}
    </h2>
    <br>
    <div class="row margin">
        <div class="col-xs-12">
            <div *ngIf="loading" id="loadingPage"></div>
            <div *ngIf="!loading" class="all">
                <div class="compositions">
                    <div class="gr-li" *ngIf="product.compositions?.length>0">
                        <p class="p-par">Compositions</p>
                        <div class="row" *ngIf="unavComp>0">
                            <div class="col-xs-12 unavailableIng">
                                <p>
                                    <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                                    moment
                                </p>
                            </div>
                        </div>
                        <div class="d-grid">
                            <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                                id="wTooltipComp{{i}}">
                                <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text" [available]="comp.available"
                                    placement="bottom" containerClass="customClass">
                                </onoffswitch>
                            </div>
                        </div>
                    </div>
                    <div class="gr-li" *ngIf="product.maxNbrIngOptions>0">
                        <p class="p-par">
                            <ng-container *ngIf="(product.optionIngredients|groupByCategory).length>1">Options
                            </ng-container>
                            <ng-container *ngIf="(product.optionIngredients|groupByCategory).length==1">
                                {{(product.optionIngredients|groupByCategory)[0].category}}</ng-container>
                            : {{product.maxNbrIngOptions}} max
                        </p>
                        <p *ngIf="unavOpt>0">
                            <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                            moment
                        </p>
                        <div class="text-gray" *ngIf="product.obligatoryIngredient.length>0">
                                <label>Obligatoire</label>
                                <label *ngFor="let ing of product.obligatoryIngredient">
                                    {{ing.category}} : {{ing.maxNbrIngOptions}} ingrédient(s)
                                </label>
                        </div>
                        <ul>
                            <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                                <p class="p-col" *ngIf="(product.optionIngredients|groupByCategory).length>1">
                                    {{c.category}} :</p>
                                <div class="d-grid">
                                    <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                        <onoffswitch (change)="changeOption(opt)" [(ngModel)]="opt.checked"
                                            [label]="opt.text"
                                            [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                            [available]="opt.available">
                                        </onoffswitch>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="gr-li" *ngIf="product.hasSupp>0">
                        <p class="p-par">Supplément</p>
                        <p *ngIf="unavSupp>0">
                            <i class="flaticon-exclamation"></i> : Ingredient indisponible pour le
                            moment
                        </p>
                        <ul>
                            <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                                <p class="p-col">{{c.category}} :</p>
                                <div class="d-grid">
                                    <div class="check-group" *ngFor="let supp of c.elements;let i=index">
                                        <onoffswitch [(ngModel)]="supp.checked" [label]="supp.text"
                                            [available]="supp.available">
                                        </onoffswitch>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button *ngIf="!loading" class="add-to-cart btn btn-block" (click)="valider()">
        <i class="flaticon-shopping"></i>
        <span> Valider</span>
    </button>
</div>